class WaccPdpGiftDrawer extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('.wacc-pdp-gift__panel');
    this.openButtons = document.querySelectorAll('[data-wacc-gift-open]');
    this.closeButtons = this.querySelectorAll('[data-wacc-gift-close]');
    this.fields = this.querySelectorAll('[data-gift-property]');
    this.openButtons.forEach((button) => button.addEventListener('click', () => this.open(button)));
    this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close(button)));
    this.fields.forEach((field) => field.addEventListener('input', () => this.syncProperties()));
    this.fields.forEach((field) => field.addEventListener('change', () => this.syncProperties()));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
    });
  }

  open(trigger) {
    this.lastTrigger = trigger;
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    requestAnimationFrame(() => {
      const firstField = this.querySelector('input, textarea, select, button');
      firstField?.focus();
    });
  }

  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    this.syncProperties();
    this.lastTrigger?.focus();
  }

  syncProperties() {
    const form = document.querySelector('[data-wacc-pdp-product-form]');
    if (!form) return;

    this.fields.forEach((field) => {
      const propertyName = field.dataset.giftProperty;
      const inputName = `properties[${propertyName}]`;
      let hidden = Array.from(form.querySelectorAll('input[type="hidden"]')).find((input) => input.name === inputName);
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = inputName;
        form.appendChild(hidden);
      }
      hidden.value = field.value;
    });
  }
}

if (!customElements.get('wacc-pdp-gift-drawer')) {
  customElements.define('wacc-pdp-gift-drawer', WaccPdpGiftDrawer);
}
